import { format } from 'date-fns';
import { api } from 'lib/httpClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useGetRole } from 'hooks/ui/useGetRole';
import downloadFile from 'utils/downloadFile';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

async function fetchTranches({ queryKey }) {
  const [, filters] = queryKey;
  const response = await api.get('fund/list', {
    params: {
      ...filters,
    },
  });

  return response.data.data;
}

export const exportFunds = async (params) => {
  const { filenameDate, ...requestParams } = params;
  const response = await api.get(`fund/list`, {
    params: requestParams,
    responseType: 'blob',
  });

  const contentType = response.headers['content-type'];
  if (
    response.status !== 200 ||
    !(
      typeof contentType === 'string' &&
      contentType.startsWith('application/vnd.openxmlformats')
    )
  ) {
    throw Error('Unexpected export response.');
  }

  downloadFile(
    response.data,
    `Tranches export - ${format(
      filenameDate ?? new Date(),
      'dd-MM-yyyy',
    )}.xlsx`,
  );
};

export function useFunds({
  endDate,
  firmId,
  fundId,
  fundStatus,
  includeTrancheValue,
  includeInvestmentsSummary,
  keyName,
  page,
  perPage,
  startDate,
  type,
  fullyDeployed,
  leanResponse,
  fundName,
  tagId,
  snapshotDate,
  disabled,
  closedDate,
  isVCT,
  hasInvestments,
  refetchOnWindowFocus,
}: any = {}) {
  const { firmId: usersFirmId } = useGetRole();

  const tranches = useQuery({
    queryKey: [
      'tranches',
      {
        endDate,
        firmId: usersFirmId || firmId, // tranches should always be scoped to the user's firm. NB. tihs also happens on the BE
        fundId,
        fundStatus,
        includeTrancheValue,
        includeInvestmentsSummary,
        keyName,
        page,
        perPage,
        startDate,
        type,
        fullyDeployed,
        leanResponse,
        fundName,
        tagId,
        snapshotDate,
        closedDate,
        isVCT,
        hasInvestments,
      },
    ],
    queryFn: fetchTranches,
    placeholderData: keepPreviousData,
    staleTime: refetchOnWindowFocus ? 0 : QUERY_STALE_TIME_MS,
    enabled: !disabled,
    refetchOnWindowFocus: refetchOnWindowFocus ? 'always' : false,
  });

  return {
    tranches: {
      ...tranches,
      data: tranches.data?.result,
      total: tranches.data?.total,
    },
    exportFunds,
  };
}
